import { useCallback, useState } from "react";

const STORAGE_KEY = "devenv-contract-favorites";

function loadFavorites(): Set<string> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return new Set();
    return new Set(JSON.parse(raw) as string[]);
  } catch {
    return new Set();
  }
}

function saveFavorites(favorites: Set<string>): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...favorites]));
}

export function useContractFavorites(): {
  favorites: Set<string>;
  toggleFavorite: (value: string) => void;
  isFavorite: (value: string) => boolean;
} {
  const [favorites, setFavorites] = useState<Set<string>>(loadFavorites);

  const toggleFavorite = useCallback((value: string) => {
    setFavorites((prev) => {
      const next = new Set(prev);
      if (next.has(value)) {
        next.delete(value);
      } else {
        next.add(value);
      }
      saveFavorites(next);
      return next;
    });
  }, []);

  const isFavorite = useCallback(
    (value: string) => favorites.has(value),
    [favorites],
  );

  return { favorites, toggleFavorite, isFavorite };
}
